import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { placeOrderRoute } from '../../routes/routes'
import { formatUrl } from '../../util/formatUtils'

class SelectRestaurant extends Component {
  render() {
    const {
      locationId,
      delivery,
      selectDelivery,
      soldOut,
      tooLate
    } = this.props
    return (
      <div className="col-xs-12 center-xs start-sm">
        {delivery && !tooLate && !soldOut && (
          <Link
            className="button primary todaysstores-item_select"
            disabled={soldOut}
            to={formatUrl(placeOrderRoute.path, {
              locationId: locationId,
              dropoffId: delivery.deliveryDropoffId
            })}
            onClick={() => selectDelivery(delivery)}
          >
            Choose This Delivery
          </Link>
        )}
      </div>
    )
  }
}

export default SelectRestaurant
